import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled from 'styled-components';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
import media from '../../tools/media';
import IconButton from '../IconButton';
import Image from '../Image';
export var StyledPage = styled.div.withConfig({
  displayName: "Pagestyles__StyledPage",
  componentId: "sc-snr1bl-0"
})(["width:100%;padding-top:var(--dentsu-spacing-32);padding-bottom:var(--dentsu-spacing-32);&.", "-page--fullwidth{max-width:none;}", " ", " .", "-page__subtitle{margin-left:12px;}&.", "-page--banner{position:relative;.", "-page__metadata,.", "-page__title,.", "-page__description{color:var(--dentsu-color-white);}.", "-page__divider{background:none;}.", "-page__controls{.dentsu-dropdown,.dentsu-cascader .rs-picker-toggle{background-color:var(--dentsu-color-white);}}}"], prefix, media.xxlarge(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-top: var(--dentsu-spacing-40);\n    padding-bottom: var(--dentsu-spacing-40);\n  "]))), media.xxxlarge(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-top: var(--dentsu-spacing-52);\n    padding-bottom: var(--dentsu-spacing-52);\n  "]))), prefix, prefix, prefix, prefix, prefix, prefix, prefix);
export var StyledPageTop = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageTop",
  componentId: "sc-snr1bl-1"
})(["padding-left:", ";padding-right:", ";margin:0 auto;width:100%;max-width:1920px;"], rem(48), rem(48));
export var StyledPageBottom = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageBottom",
  componentId: "sc-snr1bl-2"
})(["padding-left:", ";padding-right:", ";margin:0 auto;width:100%;max-width:1920px;"], rem(48), rem(48));
export var StyledPageBanner = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageBanner",
  componentId: "sc-snr1bl-3"
})(["pointer-events:none;position:absolute;height:184px;width:100%;top:0;left:0;background:", ";background-size:cover;", " ", " &:before{content:'';width:100%;height:100%;display:block;background:linear-gradient( 90deg,rgba(0,0,0,0.35) 0%,rgba(0,0,0,0) 75% );}"], function (props) {
  return "top right url(".concat(props.src, ") no-repeat");
}, media.xxlarge(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 200px;\n  "]))), media.xxxlarge(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: 216px;\n  "]))));
export var StyledPageHeader = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeader",
  componentId: "sc-snr1bl-4"
})(["display:flex;margin-bottom:40px;position:relative;z-index:2;"]);
export var StyledPageHeaderAligner = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeaderAligner",
  componentId: "sc-snr1bl-5"
})(["min-height:120px;display:flex;justify-content:center;flex-direction:column;"]);
export var StyledPageAvailableSpace = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageAvailableSpace",
  componentId: "sc-snr1bl-6"
})(["margin-top:6px;"]);
export var StyledPageHeaderContent = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeaderContent",
  componentId: "sc-snr1bl-7"
})(["display:flex;"]);
export var StyledPageHeaderContainer = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeaderContainer",
  componentId: "sc-snr1bl-8"
})(["flex-grow:1;"]);
export var StyledPageHeaderActions = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeaderActions",
  componentId: "sc-snr1bl-9"
})(["white-space:nowrap;"]);
export var StyledPageHeaderControls = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeaderControls",
  componentId: "sc-snr1bl-10"
})(["display:flex;padding-top:14px;.", "-select{margin-left:-16px;margin-right:16px;.", "-select__value-container div{font-size:16px;}.", "-select__control{box-shadow:none;&:before{content:'';height:1px;background:var(--dentsu-color-n250);position:absolute;left:16px;bottom:0;right:16px;}&.", "-select__control--menu-is-open{box-shadow:var(--dentsu-shadow-12);&:before{display:none;}.", "-select__value-container div{color:var(--dentsu-color-blue);}.", "-select__indicator span{transform:scaleY(-1);}}}.", "-select__menu{border-top:1px solid var(--dentsu-color-fuchsia);margin-top:4px;padding:16px 0;}}.", "-cascader{margin-right:16px;}.", "-dropdown{margin-right:16px;background:transparent;.bp3-icon{transform:scale(1.2);}.", "-dropdown__backdrop::after{background:transparent;}&[aria-disabled='true']{opacity:1;.", "-dropdown__content-icon{display:none;}}}.", "-form-field{margin-bottom:0 !important;> .bp3-form-content{margin-top:0;}label.bp3-label + .bp3-form-content{margin-top:-4px;}label.bp3-label{font-size:var(--dentsu-font-size-12);color:var(--dentsu-color-black);margin-bottom:0;}}"], prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix);
export var StyledPageDivider = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageDivider",
  componentId: "sc-snr1bl-11"
})(["height:4px;background:linear-gradient( 180deg,rgba(0,0,0,0.15) 0%,rgba(0,0,0,0) 100% );width:100%;position:relative;top:-12px;margin-bottom:36px;"]);
export var StyledPageHeaderTitles = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageHeaderTitles",
  componentId: "sc-snr1bl-12"
})(["display:flex;flex-direction:column;"]);
export var StyledPageTitleContainer = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageTitleContainer",
  componentId: "sc-snr1bl-13"
})(["display:flex;align-items:flex-end;"]);
export var StyledPageTitle = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageTitle",
  componentId: "sc-snr1bl-14"
})(["padding-right:16px;font-size:var(--dentsu-font-size-24);font-weight:var(--dentsu-font-weight-bold);color:var(--dentsu-color-black);hyphens:auto;word-break:break-word;", " ", ""], media.xxlarge(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: var(--dentsu-font-size-28);\n  "]))), media.xxxlarge(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: var(--dentsu-font-size-32);\n  "]))));
export var StyledPageSubtitle = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageSubtitle",
  componentId: "sc-snr1bl-15"
})(["font-size:var(--dentsu-font-size-24);font-weight:var(--dentsu-font-weight-light);color:var(--dentsu-color-black);display:inline;", " ", ""], media.xxlarge(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: var(--dentsu-font-size-28);\n  "]))), media.xxxlarge(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-size: var(--dentsu-font-size-32);\n  "]))));
export var StyledPageDescription = styled.p.withConfig({
  displayName: "Pagestyles__StyledPageDescription",
  componentId: "sc-snr1bl-16"
})(["margin-top:12px;font-style:italic;color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);max-width:100ch;", ""], media.xxxlarge(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: var(--dentsu-font-size-16);\n  "]))));
export var StyledPageStatus = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageStatus",
  componentId: "sc-snr1bl-17"
})(["display:inline-flex;vertical-align:text-bottom;font-weight:400;margin-left:12px;"]);
export var StyledPageContent = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageContent",
  componentId: "sc-snr1bl-18"
})(["> .", "-list > .", "-list__head{background:var(--dentsu-color-n50);position:sticky;}"], prefix, prefix);
export var StyledPageMetadata = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageMetadata",
  componentId: "sc-snr1bl-19"
})(["text-transform:uppercase;color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);margin-bottom:4px;"]);
export var StyledPageBreadcrumb = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageBreadcrumb",
  componentId: "sc-snr1bl-20"
})(["margin-bottom:28px;.", "-link:before{content:'/';display:inline-block;padding:0 8px;}.", "-link:first-child{margin-left:-20px;&:before{content:none;}}&:empty{displa:none;}"], prefix, prefix);
export var StyledPageThumbnailContainer = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageThumbnailContainer",
  componentId: "sc-snr1bl-21"
})(["position:relative;width:120px;height:120px;margin-right:16px;"]);
export var StyledPageThumbnail = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageThumbnail",
  componentId: "sc-snr1bl-22"
})(["width:120px;height:120px;padding:26px;background:var(--dentsu-color-white);border-radius:60px;display:flex;align-items:center;justify-content:center;border:1px solid var(--dentsu-color-n250);"]);
export var StyledPageThumbnailImage = styled(Image).withConfig({
  displayName: "Pagestyles__StyledPageThumbnailImage",
  componentId: "sc-snr1bl-23"
})(["max-width:100%;"]);
export var StyledPageBannerImage = styled(Image).withConfig({
  displayName: "Pagestyles__StyledPageBannerImage",
  componentId: "sc-snr1bl-24"
})(["width:100%;height:100%;"]);
export var StyledPageThumbnailAction = styled(IconButton).withConfig({
  displayName: "Pagestyles__StyledPageThumbnailAction",
  componentId: "sc-snr1bl-25"
})(["position:absolute;top:0;right:0;"]);
export var StyledPageSlots = styled.div.withConfig({
  displayName: "Pagestyles__StyledPageSlots",
  componentId: "sc-snr1bl-26"
})(["display:flex;"]);